<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

        /*jQuery(document).ready(function() {
        
          $("ul.list-menu li.menu-lv-item a span.text").each(function() {
            var menuText = $(this).text().trim();
            if (menuText === "Catalogo" || menuText === "BMW" || menuText === "Mercedes-Benz") {
              $(this).closest("li.menu-lv-item").hide();
            }
          });
        
          $("#themevale_select-level-1 ul li").each(function() {
            var menuText = $(this).text().trim();
            if (menuText === "Marca" || menuText === "Mercedes-Benz" || menuText === "BMW") {
              $(this).hide();
            }
          });
          
        });*/

/* fix menu toggle mobile */
jQuery(document).ready(function() {
  /*$(".mobileMenu-toggle").on("click", function(e){
    e.preventDefault();
  });*/
  $(".mobileMenu-toggle").attr("href", "https://accessori.autotorino.it/collections");
});
